import { useRef } from "react";

import { ITenantInfo, tenantService } from "@/common/services/tenant";

export interface UseCurrentTenantInfoV2HookResult {
  /** Whether the result is initialized and ready for usage. */
  isInited: boolean;
  /** Whether app is in global context without tenant specified. */
  isGlobalContext: boolean;
  /** Whether app is in tenant scoped context with tenant specified. */
  isTenantContext: boolean;
  tenantInfo: Nil<ITenantInfo>;
}

/** Returns currently resolved tenant identifier. */
export function useCurrentTenantInfoV2(): UseCurrentTenantInfoV2HookResult {
  const resultRef = useRef<UseCurrentTenantInfoV2HookResult>({
    isInited: false,
    isGlobalContext: false,
    isTenantContext: false,
    tenantInfo: null,
  });
  if (!resultRef.current.isInited && !resultRef.current.tenantInfo) {
    const tenantInfo = tenantService.resolveTenant();
    resultRef.current.isInited = true;
    resultRef.current.isGlobalContext = !tenantInfo?.identifier;
    resultRef.current.isTenantContext = !!tenantInfo?.identifier;
    resultRef.current.tenantInfo = tenantInfo;
  }

  return resultRef.current;
}
